/**
 * REWE Digital GmbH.
 * IT-Verticals
 *
 * zr-warning-notice component
 */

@use "../zr-css-icon/zr-css-icon.scss" as i;
@use "../zr-theme/zr-variables.scss" as *;
@use '../zr-theme/functions/fonts' as f;


// component name
$component: 'zr-tooltip';

.#{$component}__wrapper {
    opacity: 0;
    animation-name: show-hide-animation;
    animation-duration: 2s;
    animation-iteration-count: 1;
}

.#{$component}__content {
    position: relative;
    width: max-content;
    padding: 4px 8px 8px;
    font-size: f.calc-em(12);
    font-weight: bold;
    background-color: var(--zr-tooltip-background-color, var(--ci-tooltip, #705fdd));
    border-radius: 8px;
    color: var(--ci-neutral300);

    &.is-animated {
        position: absolute;
        right: 40px;
        top: -18px;
        transform:translateY(-100%);
    }

    &::after {
        content: '';
        position: absolute;
        bottom: 0;
        top: 100%;
        right: 24px;
        margin-bottom: -20px;
        border: 10px solid transparent;
        border-top-color: var(--zr-tooltip-background-color, var(--ci-tooltip, #705fdd));
        border-left: 0;
    }
}

.#{$component}__content.show-icon {
    @include i.get-icon-left(checkmark);

    &::before {
        height: 16px;
        width: 16px;
        margin-bottom: -3px;
        margin-right: 4px;
        background-color: var(--ci-neutral100, #fff)
    }
}

// failed state
.is-failed {
    .#{$component}__content {
        background-color: var(--ci-error);

        &::after {
            border-top-color: var(--ci-error);
        }
    }
}

@keyframes show-hide-animation {
    0% {
        opacity: 0;
    }

    15% {
        opacity: 1;
    }

    75% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}

